import "core-js/modules/es.array.reduce.js";
import BuyWorkModal from '@/frontend/modals/BuyWorkModal';
import PriceWorkModal from '@/frontend/modals/PriceWorkModal';
import SlidersApi from '@/frontend/api/sliders';
import WorksApi from '@/frontend/api/works';
import CompilationsApi from '@/frontend/api/compilations';
import CategoriesApi from '@/frontend/api/categories';
import NewWorksApi from '@/frontend/api/newWorks';
import WorksFilterComponent from '@/frontend/components/WorksFilterComponent';
import { ref, onMounted, watch, markRaw } from 'vue';
import EmptyResultComponent from '@/frontend/components/EmptyResultComponent';
import { ElLoading, ElMessage } from 'element-plus';
import { mapGetters } from 'vuex';
import setMetas from '@/frontend/functions/setMetas';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
export default {
  name: "IndexPage",
  components: {
    WorksFilterComponent,
    WorkCardComponent,
    EmptyResultComponent
  },

  data() {
    return {
      Sliders: [],
      Works: [],
      Compilations: [],
      Categories: [],
      worksLoader: {
        load: false,
        title: 'Пусто',
        description: 'Нет работ, соответствующих заданным параметрам отбора'
      },
      newWorks: [],
      buyWorkId: undefined,
      priceWorkId: undefined
    };
  },

  computed: { ...mapGetters(['modalResult'])
  },
  watch: {
    modalResult(result) {
      if (result.type === 'success') {
        if (result.modalName === 'PriceWorkModal') {
          this.$nextTick(() => {
            let loader = ElLoading.service({
              text: 'Загрузка'
            });
            this.$store.dispatch('resultModal', {});
            WorksApi.requestPrice(this.priceWorkId, result.data).then(response => ElMessage.success(response.message)).catch(handlerErrorRequest).finally(() => loader.close());
          });
        } else {
          this.$nextTick(() => {
            let loader = ElLoading.service({
              text: 'Загрузка'
            });
            this.$store.dispatch('resultModal', {});
            WorksApi.requestBuy(this.buyWorkId, result.data).then(response => ElMessage.success(response.message)).catch(handlerErrorRequest).finally(() => loader.close());
          });
        }
      }
    }

  },

  created() {
    setMetas('index');
    SlidersApi.get().then(response => this.Sliders = response);
    WorksApi.get({
      expand: ['author'].join(','),
      'per-page': 9
    }).then(response => {
      this.Works = response.items;
      this.Works.forEach(value => {
        value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
      });
    });
    CompilationsApi.get().then(response => this.Compilations = response.items);
    CategoriesApi.get().then(response => this.Categories = response);
    NewWorksApi.get({
      'sort': '_order',
      expand: ['work', 'work.author'].join(',')
    }).then(response => {
      this.newWorks = response.items;
      this.newWorks.forEach(value => {
        value.work.price = value.work.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
      });
    });
  },

  methods: {
    openBuyModal() {
      this.$store.dispatch('modal', {
        component: markRaw(BuyWorkModal),
        options: {
          dialog: {
            visible: true
          }
        }
      });
    },

    openPriceModal() {
      this.$store.dispatch('modal', {
        component: markRaw(PriceWorkModal),
        options: {
          dialog: {
            visible: true
          }
        }
      });
    },

    filterWorks(authorIds = [], years = []) {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      this.worksLoader.load = false;
      WorksApi.get({
        'filter[year][in]': years,
        'filter[authorId][in]': authorIds,
        'per-page': 9,
        expand: ['author'].join(',')
      }).then(response => {
        this.Works = response.items;
        this.Works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.worksLoader.load = true;
        loader.close();
      });
    }

  },

  setup() {
    const slider = ref(null);
    const catalogSlider = ref(null);
    const newWorkSlider = ref(null);
    onMounted(() => {
      watch(() => [slider, catalogSlider, newWorkSlider], () => {
        if (slider.value && window.sliderInit) window.sliderInit(slider.value);
        if (catalogSlider.value && window.catalogSliderInit) window.catalogSliderInit(catalogSlider.value);
        if (newWorkSlider.value && window.newWorkSliderInit) window.newWorkSliderInit(newWorkSlider.value);
      }, {
        deep: true,
        immediate: true
      });
    });
    return {
      slider,
      catalogSlider,
      newWorkSlider
    };
  }

};